import { Button, ButtonType } from '@xemplo/button';
import { DawnAddPlus } from '@xemplo/icons';

interface CreateCompanyUserButtonProps {
  onClick: () => void;
  renderButton?: (onClick: () => void) => React.ReactNode;
}

export function CreateCompanyUserButton({
  onClick,
  renderButton,
}: Readonly<CreateCompanyUserButtonProps>) {
  if (renderButton) return <>{renderButton(onClick)}</>;

  return (
    <Button
      ariaLabel="Create new company user button"
      type={ButtonType.Primary}
      onClick={onClick}
      icon={<DawnAddPlus fontSize={24} />}
    >
      New User
    </Button>
  );
}
